import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { withNavigation } from '../actions/navigation';
import DomainList from '../components/subscriptions/DomainList';

import {
  fetchSubscriptionDomains,
  fetchSubscription,
} from '../actions/subscriptions';

import {
  inviteDomainBySubscriptionId,
  removeDomainByDomainInvitationId
} from '../actions/domains';

/**
 * Subscription invitations container
 */

const mapStateToProps = ({ subscriptionsById, usersById }, { subscription, user }) => {
  const productName = subscriptionsById[subscription.id].plan.product.name;
  const pagination = subscriptionsById[subscription.id].domains;
  const principalDomain = usersById[user.id].principalDomain;
  return {
    productName,
    pagination,
    principalDomain,
  }
}

const mapDispatchToProps = (dispatch, { subscription }) => {
  const handleLoadPage = (limit, token) => {
    return dispatch(fetchSubscriptionDomains(subscription.id, limit, token))
  }
  return {
    handleLoadPage,
    
    handleInviteDomains: (domain) => 
      dispatch(inviteDomainBySubscriptionId(subscription.id, domain))
        .then(() => dispatch(fetchSubscription(subscription.id))),

    handleRemoveDomainInvitation: (domain) => 
      dispatch(removeDomainByDomainInvitationId(domain.id, subscription.id, domain.name))
        .then(() => dispatch(fetchSubscription(subscription.id))),
  }
}

const SubscriptionDomains = compose(
  withNavigation,
  connect(mapStateToProps, mapDispatchToProps)
)(DomainList);

SubscriptionDomains.propTypes = {
  subscription: PropTypes.object.isRequired
}

export default SubscriptionDomains;


// WEBPACK FOOTER //
// ./src/containers/SubscriptionDomains.js